import React from 'react';
import { Alert, AlertTitle, SxProps, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GhgSupplierSurveySchema } from 'src/Ghg/interfaces';

type Props = {
  target?: Pick<
    GhgSupplierSurveySchema,
    'environment_name' | 'branch_name' | 'branch_country_name'
  >;
  sx?: SxProps<Theme>;
};

// Where a registration through this Raben link lands -- the environment and
// the branch, as the backend resolves them from the link itself. Shown on the
// survey intro and on the registration form, so that a link of the wrong
// environment or branch (e.g. an old demo link) is noticed before an account
// is created there (2026-10-12: a carrier registered through a demo link and
// stayed invisible to the Raben administrators).
export default function RegistrationTarget({ target, sx }: Props) {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'registration_raben.linkTarget',
  });
  if (!target?.environment_name) return null;

  const branch =
    target.branch_name && target.branch_country_name
      ? t('branchWithCountry', {
          country: target.branch_country_name,
          branch: target.branch_name,
        })
      : target.branch_name;

  return (
    <Alert severity="info" sx={sx} data-testid="registration-target">
      <AlertTitle>{t('title')}</AlertTitle>
      <div>
        {t('programme')}: <strong>{target.environment_name}</strong>
      </div>
      {branch && (
        <div>
          {t('branch')}: <strong>{branch}</strong>
        </div>
      )}
      <div style={{ marginTop: '8px' }}>{t('hint')}</div>
    </Alert>
  );
}
